@if (!showPerformanceScreen) {
  <section class="py-3">
    <div class="container-fluid card card-div inner-scroll">
      <div class="row d-flex justify-content-between align-items-center g-3">
        <div class="col-12 col-md-8 sku-ledger-widget d-flex flex-column align-items-start">
          @if (heading.label) {
            <span class="label-text text-muted mb-1">{{heading.label}}</span>
          }
          <div class="sku-badge px-3 px-md-4 py-2 mb-2 d-inline-block">
            <h2 class="sku-name fw-bold m-0 text-break">{{heading.main}}</h2>
          </div>
          @if (heading.footer) {
            <span class="footer-text text-muted small">{{heading.footer}}</span>
          }
        </div>
        <div
          class="col-12 col-md-4 d-flex align-items-center gap-2 justify-content-between justify-content-md-end flex-wrap">
          @if (isFilterApplied) {
            <button class="btn purple-btn flex-grow-1 flex-md-grow-0"
              (click)="openPerformance()">
              <span class="fw-bold small">Performance insights</span>
            </button>
          }
          @if (isFilterApplied) {
            <button class="btn fw-bold filter-toggle flex-grow-1 flex-md-grow-0" (click)="showFilterPanel = !showFilterPanel">
              <fa-icon class="me-1 text-dark" [icon]="faSliders" size="sm"></fa-icon>
              <span class="text-dark fw-bold small">Filters</span>
              @if (showFilterPanel) {
                <fa-icon class="ms-1" [icon]="faAngleDown" size="sm"></fa-icon>
              }
              @if (!showFilterPanel) {
                <fa-icon class="ms-1" [icon]="faAngleUp" size="sm"></fa-icon>
              }
            </button>
          }
        </div>
      </div>
      <!-- Filter form -->
      @if (showFilterPanel) {
        <div class="card p-3 p-md-4 mt-3 rounded-4 shadow-sm border-0 custom-card-border">
          <h5 class="fw-bold mb-3 mb-md-4 heading-text text-dark-title">Filters</h5>
          <form [formGroup]="filterForm">
            <div class="row g-0">
              <!-- Left Column -->
              <div class="col-12 col-md-5 pe-md-4">
                <!-- Tyre size -->
                <div class="mb-3">
                  <label for="tyreSizeSelect" class="custom-label">Tyre size</label>
                  <div class="position-relative search-select-wrapper">
                    <i class="search-icon">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#94a3b8"
                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <circle cx="11" cy="11" r="8"></circle>
                        <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                      </svg>
                    </i>
                    <ng-select labelForId="tyreSizeSelect" [items]="tyreSizeList" bindLabel="tyreSize" bindValue="tyreSize"
                      [multiple]="false" [clearable]="true" [searchable]="true"
                      placeholder="Search tyre size..." formControlName="tyreSize"
                      class="custom-search-select" (scrollToEnd)="scrollTyreSize()"
                      (search)="onTyreSizeInputChange($event)" (close)="onSizeClose()" (clear)="onSizeClose()"
                      (change)="changeTyreSize()" [searchFn]="customSearchFn">
                      <ng-template ng-label-tmp let-item="item">
                        <span class="selected-text">{{item.tyreSize}}</span>
                      </ng-template>
                      <ng-template ng-option-tmp let-item="item">
                        <span class="selected-text">{{item.tyreSize}}</span>
                      </ng-template>
                    </ng-select>
                  </div>
                </div>
                <!-- Brand -->
                <div class="mb-3">
                  <label for="brandSelect" class="custom-label">Brand</label>
                  <div class="position-relative search-select-wrapper">
                    <i class="search-icon">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#94a3b8"
                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <circle cx="11" cy="11" r="8"></circle>
                        <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                      </svg>
                    </i>
                    <ng-select labelForId="brandSelect" [items]="tyreMakeList" bindLabel="item" bindValue="item" [multiple]="false"
                      [clearable]="true" [searchable]="true" placeholder="Search brand..."
                      formControlName="tyreMake" (change)="onMakeSelected()" class="custom-search-select"
                      (search)="onTyreMakeInputChange($event)" (close)="onMakeClose()" (clear)="onMakeClose()"
                      [searchFn]="customSearchFn">
                      <ng-template ng-label-tmp let-item="item">
                        <span class="selected-text">{{item}}</span>
                      </ng-template>
                      <ng-template ng-option-tmp let-item="item">
                        <span class="selected-text">{{item}}</span>
                      </ng-template>
                    </ng-select>
                  </div>
                </div>
                <!-- Pattern -->
                <div class="mb-3">
                  <label for="patternSelect" class="custom-label">Pattern</label>
                  <div class="position-relative search-select-wrapper">
                    <i class="search-icon">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#94a3b8"
                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <circle cx="11" cy="11" r="8"></circle>
                        <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                      </svg>
                    </i>
                    <ng-select labelForId="patternSelect" [items]="tyreModelList" bindLabel="item" bindValue="item" [multiple]="false"
                      [clearable]="true" (change)="onChangeApplyFilter()" [searchable]="true"
                      placeholder="Search pattern..." formControlName="tyreModel" [readonly]="!filterForm.get('tyreSize')?.value || !filterForm.get('tyreMake')?.value"
                      class="custom-search-select">
                      <ng-template ng-label-tmp let-item="item">
                        <span class="selected-text">{{item}}</span>
                      </ng-template>
                      <ng-template ng-option-tmp let-item="item">
                        <span class="selected-text">{{item}}</span>
                      </ng-template>
                    </ng-select>
                  </div>
                </div>
                <!-- Period -->
                <div>
                  <label for="dateDropdown" class="custom-label">Period</label>
                  <div class="dropdown w-100">
                    <button
                      class="btn w-100 d-flex justify-content-between align-items-center custom-period-btn"
                      type="button" id="dateDropdown" data-bs-toggle="dropdown" aria-expanded="false">
                      <span class="text-truncate selected-text">{{ displayRangeText || 'Select Date'
                      }}</span>
                    </button>
                    <ul class="dropdown-menu w-100 shadow-sm custom-period-menu mt-1"
                      aria-labelledby="dateDropdown">
                      @for (item of dateRanges; track item) {
                        <li class="dropdown-item cursor-pointer selected-text"
                          (click)="applyDaysRange(item.value)">
                          {{ item.label }}
                        </li>
                      }
                      <li class="dropdown-item cursor-pointer fw-medium text-dark selected-text"
                        (click)="openCalendar()">
                        Custom Date
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <!-- Right Column -->
              <div class="col-12 col-md-7 filter-divider ps-md-4">
                <!-- Branch -->
                @if (isBranchVisible) {
                  <div class="mb-3">
                    <label for="branchesSelect" class="custom-label">Branch</label>
                    <ng-select labelForId="branchesSelect" [items]="branchData" bindLabel="name" bindValue="_id" [multiple]="true"
                      [trackByFn]="trackById" [closeOnSelect]="false" [clearable]="true" [searchable]="true"
                      placeholder="Select branches..." (change)="onChangeApplyFilter()"
                      formControlName="branches" class="custom-multi-select">
                      <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                        @if (items.length > 0) {
                          <div class="ng-value custom-selected-badge">
                            <span class="ng-value-label selected-text">{{items.length}} Selected</span>
                          </div>
                        }
                      </ng-template>
                      <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                        <div class="d-flex align-items-center gap-2 py-1">
                          <input type="checkbox" [checked]="item$.selected"
                            class="form-check-input m-0 cursor-pointer" />
                            <span class="ms-1 ng-option-text selected-text">{{item.name}}</span>
                          </div>
                        </ng-template>
                      </ng-select>
                    </div>
                  }
                  <!-- Transaction Types -->
                  <div class="mb-3">
                    <label for="transactionTypesSelect" class="custom-label">Transaction types</label>
                    <ng-select labelForId="transactionTypesSelect" [items]="trxTypes" bindLabel="name" bindValue="value" [multiple]="true"
                      (change)="onChangeApplyFilter()" [closeOnSelect]="false" [clearable]="true"
                      [searchable]="true" placeholder="Select transaction types..."
                      formControlName="transactionTypes" class="custom-multi-select">
                      <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                        @if (items.length > 0) {
                          <div class="ng-value custom-selected-badge">
                            <span class="ng-value-label selected-text">{{items.length}} Selected</span>
                          </div>
                        }
                      </ng-template>
                      <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                        <div class="d-flex align-items-center gap-2 py-1">
                          <input type="checkbox" [checked]="item$.selected"
                            class="form-check-input m-0 cursor-pointer" />
                            <span class="ms-1 ng-option-text selected-text">{{item.name}}</span>
                          </div>
                        </ng-template>
                      </ng-select>
                    </div>
                    <!-- Partner Role -->
                    <div class="mb-3">
                      <span class="custom-label fw-semibold d-block mb-1">Partner Role</span>
                      <div class="d-flex gap-2">
                        @for (role of roleList; track role) {
                          <label class="role-checkbox-label flex-fill"
                            [class.role-checkbox-active]="filterForm.get('role')?.value?.includes(role)">
                            <input type="checkbox" class="role-checkbox-input"
                              [checked]="filterForm.get('role')?.value?.includes(role)"
                              (change)="onRoleToggle(role)" />
                              <span class="selected-text">{{ role }}</span>
                            </label>
                          }
                        </div>
                      </div>
                      <!-- Dealers and Customers -->
                      <div class="row g-2 " [class.g-md-3]="isBranchVisible">
                        <div class="col-12" [class.col-md-6]="isBranchVisible">
                          <label for="dealersSelect" class="custom-label">Dealers</label>
                          <ng-select labelForId="dealersSelect" [items]="dealerList" bindLabel="name" bindValue="_id" [multiple]="true"
                            [closeOnSelect]="false" (change)="onChangeApplyFilter()" [clearable]="true"
                            [searchable]="true" placeholder="Select dealers..." (close)="onDealerClose()"
                            [searchFn]="customSearchFn" (clear)="onDealerClose()"
                            formControlName="dealers" class="custom-multi-select" (scrollToEnd)="scrollDealer()"
                            (search)="onDealerInputChange($event)">
                            <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                              @if (items.length > 0) {
                                <div class="ng-value custom-selected-badge">
                                  <span class="ng-value-label selected-text">{{items.length}} Selected</span>
                                </div>
                              }
                            </ng-template>
                            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                              <div class="d-flex align-items-center gap-2 py-1">
                                <input type="checkbox" [checked]="item$.selected"
                                  class="form-check-input m-0 cursor-pointer" />
                                  <span class="ms-1 ng-option-text selected-text">{{item.name}}</span>
                                </div>
                              </ng-template>
                            </ng-select>
                          </div>
                          <div class="col-12" [class.col-md-6]="isBranchVisible">
                            <label for="customersSelect" class="custom-label">Customers</label>
                             <ng-select labelForId="customersSelect" [items]="customers" bindLabel="customerName" bindValue="_id"
                              [multiple]="true" [closeOnSelect]="false" (change)="onChangeApplyFilter()"
                              [clearable]="true" [searchable]="true" placeholder="Select customers..."
                              [loading]="customerLoading" [searchFn]="customSearchFn" formControlName="customers" class="custom-multi-select"
                              (search)="onCustomerInputChange($event)" (scrollToEnd)="scroollCustomer()"
                              (close)="onCustomerClose()" (clear)="onCustomerClose()">
                              <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                                @if (items.length > 0) {
                                  <div class="ng-value custom-selected-badge">
                                    <span class="ng-value-label selected-text">{{items.length}} Selected</span>
                                  </div>
                                }
                              </ng-template>
                              <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                <div class="d-flex align-items-center gap-2 py-1">
                                  <input type="checkbox" [checked]="item$.selected"
                                    class="form-check-input m-0 cursor-pointer" />
                                    <span class="ms-1 ng-option-text selected-text">{{item.customerName}} - {{item.phoneNumber}}</span>
                                  </div>
                                </ng-template>
                              </ng-select>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                    <!-- Action Buttons -->
                    <div class="d-flex justify-content-end align-items-center gap-2 gap-md-3 pt-2">
                      <button class="btn btn-clear d-flex align-items-center gap-2 py-2" (click)="resetFormFields()">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                          stroke-linecap="round" stroke-linejoin="round">
                          <line x1="18" y1="6" x2="6" y2="18"></line>
                          <line x1="6" y1="6" x2="18" y2="18"></line>
                        </svg>
                        <span class="small fw-bold">Clear</span>
                      </button>
                      <button class="btn btn-apply px-3 px-md-4 py-2" (click)="applyFilter()" [disabled]="!filterForm.valid || filterLoading">
                        <span class="small fw-bold">Apply filters</span>
                        @if (filterLoading) {
                          <fa-icon class="ms-1" size="sm" [icon]="faSpinner"
                          [animation]="'spin'"></fa-icon>
                        }
                      </button>
                    </div>
                  </div>
                }
                <!-- hignlight cards -->
                @if (showHighlightCards) {
                  <div class="card p-3 p-md-4 rounded-4 thick-border-gray shadow-none mt-2">
                    <p class="mb-2 mb-md-3 fw-bold heading-text">Balance summary</p>
                    <div class="row g-2 g-md-3">
                      @for (card of highlightCards; track card) {
                        <div class="col-6 col-lg-3">
                          <div class="stat-box h-100 p-2 p-md-3 rounded-3 border-gray">
                            <div class="text-muted mb-1 stat-heading text-uppercase">
                              {{ card.heading }}
                            </div>
                        <div class="stat-value" [ngClass]="{
                               'text-inward': card.key === 'totalInward',
                               'text-outward': card.key === 'totalOutward',
                               'text-default-balance': card.key === 'openingBalance' || card.key === 'closingBalance'
                             }">
                              {{
                              card.key === 'totalInward' && card.value != 0
                              ? '+' + (card.value | number)
                              : card.key === 'totalOutward' && card.value != 0
                              ? '-' + (card.value | number)
                              : (card.value | number)
                              }}
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                }
                <!-- empty table message -->
                @if (isEmptyResult) {
                  <div class="card p-2 p-md-4 rounded-4 thick-border-gray shadow-none mt-2">
                    <h3 class="fw-bold text-center mb-2 empty-title">No transactions for this SKU</h3>
                    <p class="text-center small text-muted footer-text mb-2">Nothing matches your current filters. Clear filters or try a different combination.</p>
                    <div class="d-flex align-items-center justify-content-center gap-1 mt-1">
                      <button class="btn border-gray d-flex align-items-center justify-content-center gap-1 py-1 px-2" (click)="resetFormFields()">
                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                          stroke-linecap="round" stroke-linejoin="round">
                          <line x1="18" y1="6" x2="6" y2="18"></line>
                          <line x1="6" y1="6" x2="18" y2="18"></line>
                        </svg>
                        <span class="tiny-text fw-bold">Clear filter</span>
                      </button>
                      <button class="btn border-gray d-flex align-items-center justify-content-center gap-1 py-1 px-2" (click)="adjustFilter()">
                        <fa-icon [icon]="faSliders" size="xs"></fa-icon>
                        <span class="text-dark fw-bold tiny-text">Adjust filter</span>
                      </button>
                    </div>
                  </div>
                }
                @if (showtable) {
                  <div class="card p-3 p-md-4 rounded-4 thick-border-gray shadow-none mt-2">
                    <!-- Header Section -->
                    <div class="d-flex justify-content-between align-items-center gap-2 mb-3">
                      <p class="heading-text fw-bold m-0 small">Transactions</p>
                      @if (data.length) {
                        <div class="dropdown export-dropdown">
                          <button class="btn btn-export dropdown-toggle py-1 px-3 small-btn" type="button" id="exportDropdown"
                            data-bs-toggle="dropdown" aria-expanded="false">
                            Export
                          </button>
                          <ul class="dropdown-menu shadow-sm" aria-labelledby="exportDropdown">
                            <li>
                              <a class="dropdown-item cursor-pointer" (click)="downloadPdf()">
                                <span class="fw-bold">PDF</span>
                              </a>
                            </li>
                            <li>
                              <a class="dropdown-item cursor-pointer py-1"
                                (click)="downloadExcel()">
                                <span class="fw-bold">XLS</span>
                              </a>
                            </li>
                          </ul>
                        </div>
                      }
                    </div>
                    <div class="table-responsive" infiniteScroll [scrollWindow]="false" [infiniteScrollDistance]="2"
                      [infiniteScrollThrottle]="500" (scrolled)="onscrollTable()">
                      <table class="table custom-table align-middle m-0">
                        <thead>
                          <tr class="filter-row">
                            <td></td>
                            <td></td>
                            @if (isBranchVisible) {
                              <td></td>
                            }
                            <td></td>
                            <td></td>
                            <td>
                              <div class="position-relative search-select-wrapper table-filter"
                                [formGroup]="filterForm">
                                <i class="search-icon">
                                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#64748B"
                                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                    <circle cx="11" cy="11" r="8"></circle>
                                    <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                                  </svg>
                                </i>
                                <input type="text" class="form-control table-search-input"
                                  placeholder="Filter voucher..." formControlName="voucher"
                                  (input)="onVoucherInput($event)">
                                </div>
                              </td>
                              <td>
                                <div class="position-relative search-select-wrapper table-filter"
                                  [formGroup]="filterForm">
                                  <i class="search-icon">
                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#64748B"
                                      stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                      <circle cx="11" cy="11" r="8"></circle>
                                      <line x1="21" x2="16.65" y1="21" y2="16.65"></line>
                                    </svg>
                                  </i>
                                  <ng-select #userSelect [items]="usersList" bindLabel="name" bindValue="_id"
                                    placeholder="Select user..." formControlName="addedBy" (scrollToEnd)="scroolUsers()"
                                    (change)="onChangeApplyFilter(!showFilterPanel)"
                                    class="table-ng-select" appendTo="body">
                                  </ng-select>
                                </div>
                              </td>
                              <td></td>
                              <td></td>
                              <td></td>
                            </tr>
                            <tr>
                              <th scope="col" (click)="sortingByField('date')" class="cursor-pointer">
                                <div class="d-flex align-items-center justify-content-start">
                                  <span class="me-1">DATE</span>
                                  @if (sortingFieds.date === 0) {
                                    <img src="assets/arrow-up-down.svg"
                                      class="img-icon" alt="normal">
                                  }
                                  @if (sortingFieds.date === -1) {
                                    <img src="assets/arrow-down.svg" class="img-icon" alt="down">
                                  }
                                  @if (sortingFieds.date === 1) {
                                    <img src="assets/arrow-up.svg" class="img-icon" alt="up">
                                  }
                                </div>
                              </th>
                              <th scope="col">Type</th>
                              @if (isBranchVisible) {
                                <th scope="col">Branch</th>
                              }
                              <th scope="col">Partner</th>
                              <th scope="col">Role</th>
                              <th scope="col">Voucher</th>
                              <th scope="col">Added by</th>
                              <th scope="col">Price</th>
                              <th scope="col">Qty</th>
                              <th scope="col">Balance</th>
                            </tr>
                          </thead>
                          <tbody>
                            @for (tx of data; track tx; let i = $index) {
<tr [ngClass]=" i === 0 ? 'balance-row'
                                    : tx.last ? 'balance-row': tx.neagative ? 'warning-row' : 'normal-row' ">
                                <!-- CASE 1: Balance Rows (Opening/Closing) -->
                                @if (i === 0 || tx.last) {
                                  <td class="sticky-left-balance" colspan="2">
                                    <span class="balance-text">
                                      {{ tx.date }}
                                    </span>
                                  </td>
                                  <td [attr.colspan]="isBranchVisible ? 7 : 6" class="middle-balance"></td>
                                  <td class="text-center sticky-right-balance">
                                    <span class="text-dark balance-text">
                                      {{ tx.balance | number }}
                                    </span>
                                  </td>
                                } @else {
                                  <td>
                                    <span class="table-text-one">
                                      {{ tx.date }}
                                    </span>
                                  </td>
                                  <td>
                                    <span class="badge rounded-pill type-badge" [ngClass]="{ 'bg-transfer': tx.type === 'Transfer',
                                        'bg-return': tx.type === 'Return', 'bg-purchase':( tx.type === 'Purchase' || tx.type === 'Import'),
                                        'bg-sale': tx.type === 'Sale', 'bg-adjustment':  tx.type === 'Adjust',}">
                                      {{ tx.type }}
                                    </span>
                                  </td>
                                  @if (isBranchVisible) {
                                    <td class="table-text-two fw-semibold">
                                      {{ tx.branch || '—'}}
                                    </td>
                                  }
                                  <td class="table-text-one" [ngClass]="{'cursor-pointer text-primary': tx.dealerId && tx.partner}" (click)="openDealerSummary(dealerModel, tx)">
                                    {{ tx.partner || tx.fromBranchName || tx.toBranchName || '—'}}
                                  </td>
                                  <td class="table-text-one">
                                    {{ tx.role || '—' }}
                                  </td>
                                  <td class="table-text-two" [ngClass]="{'text-primary cursor-pointer': tx.invoice}" (click)="viewVoucher(tx, pdfModel)">
                                    <span>
                                      {{ tx.voucherNo || '-' }}
                                    </span>
                                  </td>
                                  <td class="table-text-one">
                                    {{ tx.addedBy }}
                                  </td>
                                  <td class="table-text-one">
                                    @if (tx.price != 0) {
                                      ₹{{ tx.price | number}}
                                    } @else {
                                      <span>-</span>
                                    }
                                  </td>
                                  <td class="table-text-three" [ngClass]="tx.outward ? 'text-red' : 'text-green'">
                                    <span>{{tx.outward ? '-' : '+'}}</span>{{ tx.qty | number}}
                                  </td>
                                  <td class="text-center">
                                    <span class="text-dark table-text-four">
                                      {{ tx.balance | number }}
                                    </span>
                                    @if (tx.neagative) {
                                      <fa-icon class="causion-icon" [icon]="faTriangleExclamation"
                                      [ngbTooltip]="'Negative balance detected - check for missed stock-in, duplicate stock-out, incorrect transfer, or faulty adjustment'"></fa-icon>
                                    }
                                    @if(tx.isEdited) {
                                      <fa-icon class="causion-icon" [icon]="faCircleExclamation"
                                        [ngbTooltip]="'This transaction is edited'"></fa-icon>
                                    }
                                  </td>
                                }
                              </tr>
                            }
                          </tbody>
                        </table>
                        @if (loader) {
                          <div class="d-flex align-items-center justify-content-center">
                            <app-loader [loadingIcon]="loader"></app-loader>
                          </div>
                        }
                        @if (!loader && data.length==0) {
                          <div class="alert  alert-warning d-flex justify-content-center">
                            <p>There is no transactions on your current filters</p>
                          </div>
                        }
                      </div>
                    </div>
                  }
                </div>
              </section>
            }


            @if (errorMessage) {
              <app-toaster [title]="errorMessage" (closeToaster)="closeToster()"></app-toaster>
            }


            <ng-template #pdfModel let-modal>
              <div class="app-pdf-model">
                <div class="modal-header">
                  <h3>{{selectedVocher.name}}</h3>
                  <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
                </div>
                <div class="modal-body p-0">
                  <iframe [src]="selectedVocher.url" class="pdf-iframe" title="PDF Document Viewer">
                  </iframe>
                </div>
              </div>
            </ng-template>


            <ng-template #dealerModel let-modal>
              <div class="excel-model">
                <div class="modal-header border-0 pb-0">
                  <div class="d-flex justify-content-between align-items-center w-100 pe-2">
                    <h5 class="fw-bold mb-0 text-dark">{{ dealerHighlights?.dealer }}</h5>
                    <div class="d-flex align-items-center gap-2">
                      <div class="dropdown" style="width: 250px; min-width: 250px;">
                        <button class="btn btn-sm d-flex justify-content-between align-items-center w-100 border text-dark fw-bold"
                          type="button" id="dealerDateDropdown" data-bs-toggle="dropdown" aria-expanded="false"
                          style="background-color: #f8f9fa; border-radius: 6px; padding: 0.4rem 0.75rem;">
                          <span class="text-truncate small">{{ dealerHighlights?.displayRangeText || 'Select' }}</span>
                          <fa-icon [icon]="faAngleDown" class="ms-2 small opacity-50"></fa-icon>
                        </button>
                        <ul class="dropdown-menu dropdown-menu-end shadow-sm border-0 mt-1" aria-labelledby="dealerDateDropdown" style="min-width: 250px;">
                          <li><a class="dropdown-item cursor-pointer small fw-bold" (click)="applyDealerRange('all', 'All')">All</a></li>
                          @for (item of dateRanges; track item) {
                            <li>
                              <a class="dropdown-item cursor-pointer small" (click)="applyDealerRange(item.value, item.label)">{{ item.label }}</a>
                            </li>
                          }
                          <li><a class="dropdown-item cursor-pointer small" (click)="openDealerCalendar()">Custom Date</a></li>
                        </ul>
                      </div>
                      <button type="button" class="btn-close ms-0" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
                    </div>
                  </div>
                </div>

                <div class="modal-body p-3 p-md-4">
                  @if (dealerHighlights?.loader) {
                    <div class="d-flex justify-content-center py-5">
                      <app-loader [loadingIcon]="dealerHighlights?.loader"></app-loader>
                    </div>
                  }

                  @if (!dealerHighlights?.loader && dealerHighlights?.errorMessage) {
                    <div class="text-center py-4">
                      <p class="text-danger mb-0">{{ dealerHighlights.errorMessage }}</p>
                    </div>
                  }

                  @if (!dealerHighlights?.loader && !dealerHighlights?.errorMessage) {
                    <div class="row g-2 g-md-3">
                      <!-- Total Purchases -->
                      <div class="col-6 col-md-4">
                        <div class="stat-box h-100 p-2 p-md-3 rounded-3 border-gray shadow-none">
                          <div class="text-muted mb-1 stat-heading text-uppercase">Total Purchases</div>
                          <div class="stat-value text-default-balance">{{ dealerHighlights?.totalPurchases | number }}</div>
                        </div>
                      </div>
                      <!-- Last Purchase Price -->
                      <div class="col-6 col-md-4">
                        <div class="stat-box h-100 p-2 p-md-3 rounded-3 border-gray shadow-none">
                          <div class="text-muted mb-1 stat-heading text-uppercase">Last Purchase Price</div>
                          <div class="stat-value text-default-balance">₹{{ dealerHighlights?.lastPurchasePrice | number }}</div>
                        </div>
                      </div>
                      <!-- Min Price -->
                      <div class="col-6 col-md-4">
                        <div class="stat-box h-100 p-2 p-md-3 rounded-3 border-gray shadow-none">
                          <div class="text-muted mb-1 stat-heading text-uppercase">Min Purchase Price</div>
                          <div class="stat-value text-default-balance">₹{{ dealerHighlights?.minPrice | number }}</div>
                        </div>
                      </div>
                      <!-- Max Price -->
                      <div class="col-6 col-md-4">
                        <div class="stat-box h-100 p-2 p-md-3 rounded-3 border-gray shadow-none">
                          <div class="text-muted mb-1 stat-heading text-uppercase">Max Purchase Price</div>
                          <div class="stat-value text-default-balance">₹{{ dealerHighlights?.maxPrice | number }}</div>
                        </div>
                      </div>
                      <!-- Average Quantity -->
                      <div class="col-6 col-md-4">
                        <div class="stat-box h-100 p-2 p-md-3 rounded-3 border-gray shadow-none">
                          <div class="text-muted mb-1 stat-heading text-uppercase">Avg Purchase Qty</div>
                          <div class="stat-value text-default-balance">{{ dealerHighlights?.averageQuantity | number }}</div>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              </div>
            </ng-template>

            @if (showPerformanceScreen) {
              <app-performance-insights [heading]="heading.main" [selectedTyre]="tablePayload"
              (viewSkuLedger)="showPerformanceScreen = false"></app-performance-insights>
            }